import React, { useState, useEffect, useCallback } from 'react'
import { Bell } from 'lucide-react'
import { supabase } from '../supabase'

const RED = '#b8441a'
const GOLD = '#c9a84c'

export default function ClubhouseBell({ session, onClick }) {
  const userId = session?.user?.id
  const [count, setCount] = useState(0)

  const refresh = useCallback(async () => {
    if (!userId) return

    const { data: profile } = await supabase
      .from('profiles')
      .select('last_seen_clubhouse_at')
      .eq('id', userId)
      .single()

    const since = profile?.last_seen_clubhouse_at || '1970-01-01T00:00:00Z'

    const [{ count: postCount }, { count: replyCount }] = await Promise.all([
      supabase.from('forum_posts').select('id', { count: 'exact', head: true }).gt('created_at', since),
      supabase.from('forum_replies').select('id', { count: 'exact', head: true }).gt('created_at', since),
    ])

    setCount((postCount || 0) + (replyCount || 0))
  }, [userId])

  useEffect(() => {
    refresh()
    const interval = setInterval(refresh, 60000)
    return () => clearInterval(interval)
  }, [refresh])

  async function handleClick() {
    if (onClick) onClick()
    if (userId) {
      await supabase.from('profiles').update({ last_seen_clubhouse_at: new Date().toISOString() }).eq('id', userId)
    }
    setCount(0)
  }

  return (
    <button
      onClick={handleClick}
      title="Clubhouse activity"
      style={{
        position: 'relative', background: 'none', border: 'none', cursor: 'pointer',
        color: 'var(--text-muted)', padding: '0.4rem', display: 'flex', alignItems: 'center',
        justifyContent: 'center', borderRadius: '6px', transition: 'color 0.15s, background 0.15s',
      }}
      onMouseEnter={e => { e.currentTarget.style.color = GOLD; e.currentTarget.style.background = 'var(--surface-hdr)' }}
      onMouseLeave={e => { e.currentTarget.style.color = 'var(--text-muted)'; e.currentTarget.style.background = 'none' }}
    >
      <Bell size={17} strokeWidth={1.75} />
      {count > 0 && (
        <span style={{
          position: 'absolute', top: '0px', right: '0px',
          background: RED, color: '#fff', borderRadius: '99px',
          fontFamily: 'monospace', fontSize: '0.55rem', fontWeight: '700',
          minWidth: '15px', height: '15px', display: 'flex', alignItems: 'center', justifyContent: 'center',
          padding: '0 3px', lineHeight: 1,
        }}>
          {count > 9 ? '9+' : count}
        </span>
      )}
    </button>
  )
}
